//@ts-check
import React from 'react';
import Icon from '../Icon';
import getHumanFileSize from '../../utils/formatting/getHumanFileSize';
import Typography from '@material-ui/core/Typography';
var iconStyle = {
  lineHeight: '16px',
  fontSize: '.875rem'
};
/**
 * Select file from local computer
 * @typedef {object} Props RepositoryUploadSnackbarFile props
 * @property {string} name The name of the file
 * @property {string} size The size of the file
 * @property {object} uploadStatus The upload status of the file
 *
 * @param {Props} props
 */

var RepositoryUploadSnackbarFile = function RepositoryUploadSnackbarFile(_ref) {
  var name = _ref.name,
      size = _ref.size,
      _ref$uploadStatus = _ref.uploadStatus,
      response = _ref$uploadStatus.response,
      error = _ref$uploadStatus.error;
  var formattedSize = getHumanFileSize(size);
  var file = React.createElement("span", {
    style: {
      fontWeight: 'bold'
    }
  }, name);

  if (response == 'uploading') {
    return React.createElement(Typography, {
      color: "inherit"
    }, React.createElement(Icon, {
      style: iconStyle,
      type: "loading"
    }), " Uploading ", file, " (", formattedSize, ")");
  } else if (response == 'succeeded') {
    return React.createElement(Typography, {
      color: "inherit"
    }, React.createElement(Icon, {
      style: iconStyle,
      type: "check"
    }), " Uploaded ", file, " (", formattedSize, ")");
  } else if (response == 'failed') {
    return React.createElement(React.Fragment, null, React.createElement(Typography, {
      color: "inherit"
    }, React.createElement(Icon, {
      style: iconStyle,
      type: "warning"
    }), " Upload failed for ", file, " (", formattedSize, ")"), React.createElement(Typography, {
      color: "error"
    }, error));
  } else {
    return null;
  }
};

export default RepositoryUploadSnackbarFile;